import React from 'react';

import { AiIcon } from '../AiIcon/AiIcon';
import { AiBadge, AssistantName, Avatar, HeaderContainer } from './AiMessageHeader.styled';

export interface AiMessageHeaderProps {
  /** Name of the AI assistant */
  assistantName: string;
  /** Optional custom avatar URL */
  avatarUrl?: string;
  /** Additional CSS class names */
  className?: string;
}

/**
 * AiMessageHeader Component
 * 
 * Header displayed above AI assistant messages showing avatar and name.
 * Falls back to sparkle icon if no custom avatar is provided.
 * 
 * Features:
 * - Custom avatar support via URL
 * - Sparkle icon fallback
 * - "AI" badge indicator
 * - Responsive font sizing
 * 
 * @example
 * ```tsx
 * <AiMessageHeader 
 *   assistantName="Community Assistant"
 *   avatarUrl="https://example.com/avatar.png"
 * />
 * ```
 */
export const AiMessageHeader: React.FC<AiMessageHeaderProps> = ({
  assistantName,
  avatarUrl,
  className = '',
}) => {
  return (
    <HeaderContainer className={className}>
      {/* Avatar or sparkle icon */}
      {avatarUrl ? (
        <Avatar src={avatarUrl} alt={assistantName} />
      ) : (
        <AiIcon height={24} />
      )}

      {/* Assistant name */}
      <AssistantName>{assistantName}</AssistantName>

      {/* AI badge */}
      <AiBadge>AI</AiBadge>
    </HeaderContainer>
  );
};

export default AiMessageHeader;
